import { defineComponent } from 'vue';
import { MdTypography, MdButton, MdIconClose, MdIconAgreements, MdLink, MdIconLock } from '@antiqua-dls/vue-components'

export default defineComponent({
    components: {
        MdTypography,
        MdButton,
        MdIconClose,
        MdIconAgreements,
        MdLink,
        MdIconLock
    },
    props: {
        heading: {
            type: String,
            required: true
        },
        body: {
            type: String,
            required: true
        },
        btnText: {
            type: String,
            required: true
        },
        agreementButtonDisabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: ['handleButtonAction', 'closeSmallPopupInfoModal'],
    setup(props, { emit }) {
        const handleButtonClick = () => {
            emit('handleButtonAction')
            closeModal();
        }
        const closeModal = () => {
            emit('closeSmallPopupInfoModal')
        }
        return {
            handleButtonClick,
            closeModal
        };
    }
});